import React, { createContext, useContext, ReactNode } from 'react';
import { useCompanyConfig } from '../hooks/useCompanyConfig';

interface CompanyConfigMap {
  [key: string]: string | number | boolean;
}

interface CompanyConfigContextType {
  configs: CompanyConfigMap;
  companyName: string;
  loading: boolean;
  error: Error | null;
  getConfig: (key: string, defaultValue?: any) => any;
  isModuleActive: (moduleName: 'compte' | 'magasin' | 'offres' | 'factures') => boolean;
}

const CompanyConfigContext = createContext<CompanyConfigContextType | undefined>(undefined);

interface CompanyConfigProviderProps {
  children: ReactNode;
  env?: 'production' | 'preproduction' | 'development';
}

export const CompanyConfigProvider: React.FC<CompanyConfigProviderProps> = ({ 
  children, 
  env = 'production' 
}) => {
  const companyConfig = useCompanyConfig(env);

  return (
    <CompanyConfigContext.Provider value={companyConfig}>
      {children}
    </CompanyConfigContext.Provider>
  );
};

export const useCompanyConfigContext = (): CompanyConfigContextType => {
  const context = useContext(CompanyConfigContext);
  if (!context) {
    throw new Error('useCompanyConfigContext must be used within a CompanyConfigProvider');
  }
  return context;
};
